module.exports = __webpack_public_path__ + "static/VWT20_Funktion01_Paket_800x800-200x200-2d6a4f45c013ad1ac8b7fc5b06aa0c0b.png";